import * as Yup from 'yup';
import { IModel } from '~/lib/model';

export interface IPlacement extends IModel {
    id?: string;
    name: string;
    platform: string;
    bundle: string;
    adType: string;
    placementType: string;
    hva: boolean;
    pricefloor?: number | null;
    gpid?: string | null;
    maxAdUnitId?: string | null;
}

export const PlacementSchema = Yup.object().shape<IPlacement>({
    id: Yup.string().nullable(),
    name: Yup.string().required('is required').nullable(false).max(100),
    platform: Yup.string().required('is required').nullable(false),
    bundle: Yup.string().required('is required').nullable(false),
    adType: Yup.string().required('is required').nullable(false),
    placementType: Yup.string().required('is required').nullable(false),
    hva: Yup.boolean().required('is required'),
    pricefloor: Yup.number()
        .when('placementType', {
            is: 'waterfall',
            then: (schema: Yup.NumberSchema) => schema.required('is required').min(0, 'must be >= 0'),
        })
        .nullable(),
    gpid: Yup.string().nullable(),
    maxAdUnitId: Yup.string()
        .trim()
        .nullable()
        .matches(/^[0-9a-f]{16}$/, { message: 'must be 16 lowercase hex characters', excludeEmptyString: true }),
});

export const defaultPlacement: IPlacement = {
    id: '',
    name: '',
    platform: '',
    bundle: '',
    adType: '',
    placementType: 'bidding',
    hva: false,
    pricefloor: null,
    gpid: null,
    maxAdUnitId: null,
  };

export interface IImportSourceCounts {
    sourceId: number;
    created: number;
    updated: number;
    skipped: number;
}

export interface IImportSkippedRow {
    row: number;
    adUnitName: string;
    reason: string;
}

export interface IImportResult {
    created: number;
    updated: number;
    skipped: number;
    bySource: IImportSourceCounts[];
    skippedRows: IImportSkippedRow[];
    csv: string;
}
